import { render, staticRenderFns } from "./AguardandoAprovacaoComponent.vue?vue&type=template&id=f720da00&scoped=true"
import script from "./AguardandoAprovacaoComponent.vue?vue&type=script&lang=js"
export * from "./AguardandoAprovacaoComponent.vue?vue&type=script&lang=js"
import style0 from "./AguardandoAprovacaoComponent.vue?vue&type=style&index=0&id=f720da00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f720da00",
  null
  
)

export default component.exports